import api from '@/services/api';

const ContractPartyMasterQuery = {
  filterContractPartyMasterByCompanyId: () => {
    return api.get('filter_contract_party_master_by_company_id/');
  }
};

export default ContractPartyMasterQuery;



// WEBPACK FOOTER //
// ./src/api/user_contract/contract_party_master/query.js